
import React, { useEffect, useRef } from 'react';

const Avatar = (props) => {
    const src = props.src
    const alt = props.alt

    return (
        // <div style={{display: 'flex', height: '100%', flexGrow: 1}}>
            <img

                style={{
                    borderRadius: '100%',
                    border: '2px #d3d3d3 solid',
                    width: '100%',
                    height: '100%',
                    aspectRatio: 1/1,
                    cursor: 'pointer',
                    objectFit: "cover"
                }}
                onClick={()=>{
                    if(props.onClick){
                        props.onClick()
                    }
                }}
                src={src || "https://apisgi.intecsolutions.com.br/files/user_placeholder.jpg"}
                alt={alt || "Avatar"}
            />
        // </div>
    );
};

export default Avatar;
